import { render, staticRenderFns } from "./PowerNumeration.vue?vue&type=template&id=1d922d96&"
import script from "./PowerNumeration.vue?vue&type=script&lang=js&"
export * from "./PowerNumeration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports